import { Image, View } from '@react-pdf/renderer';
import React from 'react';
import { Text } from './Text';

export default function ProductRow({ product, ...rest }) {
  const analyticsString = [
    product.designation,
    product.alcohol && `Alc. ${product.alcohol}%`,
    product.residualSugar && `TS ${product.residualSugar} g/l`,
    product.totalAcidity && `GS ${product.totalAcidity} g/l`,
  ]
    .filter(Boolean)
    .join(' | ');
  return (
    <View
      style={{
        flexDirection: 'row',
        height: '20.5mm',
        flexShrink: 0,
        paddingVertical: '2mm',
      }}
      {...rest}
    >
      <View
        style={{ flexDirection: 'row', justifyContent: 'center', width: 30 }}
      >
        {product.bottleImage?.fixed?.src ? (
          <Image src={product.bottleImage?.fixed?.src} style={{ height: 40 }} />
        ) : (
          <View style={{ height: 40 }} />
        )}
      </View>
      <View style={{ marginLeft: '3mm' }}>
        <Text variant="bold">
          {product.shortName} {product.vintage}
        </Text>
        <Text>{product.denomination}</Text>
        <Text>{grapeVarietyString(product)}</Text>
        <Text>{analyticsString}</Text>
        {product.tastingNote && (
          <Text>
            {product.tastingNote.rating}/5 - {product.tastingNote.note}
          </Text>
        )}
      </View>
    </View>
  );
}

function grapeVarietyString({ grapeVarieties }) {
  return grapeVarieties
    ?.map(({ percentage, varietyName }) => {
      return percentage ? `${percentage}% ${varietyName}` : `${varietyName}`;
    })
    .join(', ');
}
